/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VantageWorkflow,
    VantageWorkflowFromJSON,
    VantageWorkflowFromJSONTyped,
    VantageWorkflowToJSON,
} from './';

/**
 * 
 * @export
 * @interface VantageWorkflows
 */
export interface VantageWorkflows {
    /**
     * 
     * @type {Array<VantageWorkflow>}
     * @memberof VantageWorkflows
     */
    workflows: Array<VantageWorkflow>;
}

export function VantageWorkflowsFromJSON(json: any): VantageWorkflows {
    return VantageWorkflowsFromJSONTyped(json, false);
}

export function VantageWorkflowsFromJSONTyped(json: any, ignoreDiscriminator: boolean): VantageWorkflows {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workflows': ((json['workflows'] as Array<any>).map(VantageWorkflowFromJSON)),
    };
}

export function VantageWorkflowsToJSON(value?: VantageWorkflows | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'workflows': ((value.workflows as Array<any>).map(VantageWorkflowToJSON)),
    };
}


